export default {
  storeDistanceColor: Styles.color.black,
  storeHoursInfoColor: Styles.color.primary,
  availableServiceModesTextColor: Styles.color.black,
};
